import type { JSXElement, ParentComponent } from "solid-js"

interface ListItemProps {
  children: JSXElement
}

const ListItem: ParentComponent<ListItemProps> = (props) => {
  return <li class="list-group-item text-center">{props.children}</li>
}

export default ListItem